import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class UploadService {
    public options: any = {
        url: '/documenten/basic/upload/default',
        autoUpload: true,
        multiple: true,
        maxFileSize: 25 * 1024 * 1024,  // 25 MB
    };
    public files: any[] = [];

    constructor() {}

    handle(data: any): void {
        if (data && data.response) {
            this.add(data.response['_files'][0]);
        }
    }

    hasFiles(): boolean {
        return this.files.length > 0;

    }

    remove(file: any): void {
        const index = this.files.indexOf(file);
        this.files.splice(index, 1);
    }

    add(file: any): void {
        const duplicate = this.findOneByPrefix(file.name.substr(0, 4));

        if (duplicate) {
            this.remove(duplicate);
        }

        this.files.push(file);
    }

    findOneByPrefix(filename: string): any[] {
        return this.files.find(file => {
            return file.name.search(filename) === 0;
        });
    }

    getFirst(): any {
        return this.files[0];
    }

    clear(): void {
        this.files = [];
    }

    get maximumFileSizeInMB(): number {
        return this.options.maxFileSize / 1024 / 1024;
    }
}
